var exports = {
  "z": "root__x-tO8z",
  "V": "grid__OQ_Sat",
};

module.exports = exports;
